import React from "react";
import { connect } from "react-redux";
import Loading from "./Loading";
import { bindActionCreators } from "redux";
import Notifications from "react-notification-system-redux";
import T from "i18n-react";
import translations from "../locales";
import { replace } from "connected-react-router";
import { Route } from "react-router-dom";
import DokivShareForm from "../pages/DokivShareForm";
import DokivShareFormAuth from "../pages/DokivShareFormAuth";
import {Switch} from "react-router-dom";

const mapStateToProps = ({ 
  notifications, 
  uploadEnQueueFiles, 
  Root: { langKey }
}) => ({
  notifications,
  uploadEnQueueFiles,
  langKey
});

const mapDispatchToProps = () => dispatch => ({
  dispatch
});

class App extends React.Component {
  removeUploadFile = f => {
    f.abort();
    this.props.dispatch({
      type: "REMOVE_FILE_UPLOADED",
      id: f.id
    });
  };

  componentDidMount() {
    if(!window.localStorage.language){
      fetch('https://d.pub.network/v2/init?siteId=583&env=PROD')
       .then( res => res.json())
       .then(response => {
          let stringCodeEn = 'GB/GBR/UM/UMI/US/USA/VI/VIR/AS/ASM';
          if(stringCodeEn.indexOf(response.location.countryCode)>-1){
            window.localStorage.language = 'en';
          }else{
            window.localStorage.language = 'se';
          }
          T.setTexts(translations[window.localStorage.language]);
        })
        .catch((data, status) => {
          window.localStorage.language = 'se';
          T.setTexts(translations[window.localStorage.language]);
        });
    }else{
      T.setTexts(translations[window.localStorage.language]);
    } 
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.langKey !== this.props.langKey) {
      T.setTexts(translations[nextProps.langKey]);
    }
  }

  render() {
    let { notifications } = this.props;
    return (
      <div>
        <div className="main-view">
          <Switch>
            <Route exact path="/forms/:shareId" component={DokivShareForm} />
            <Route exact path="/forms/:shareId/auth" component={DokivShareFormAuth} />
          </Switch>
        </div>
        {this.props.uploadEnQueueFiles && this.props.uploadEnQueueFiles.files
          ? <ul className="progress-bar__wrap">
              {this.props.uploadEnQueueFiles.files.map((f, i) =>
                <li
                  key={i}
                  className={
                    "progress-bar__file " + f.uploadStatus.toLowerCase()
                  }
                >
                  <div className="progress-bar__info">
                    {f.uploadStatus === "INPROGRESS"
                      ? <b>
                          {T.translate("uploading")}:
                        </b>
                      : null}
                    {f.uploadStatus === "COMPLETE"
                      ? <b>
                          {T.translate("complete")}:
                        </b>
                      : null}
                    {f.uploadStatus === "ERROR"
                      ? <b>
                          {T.translate("upload-error")}:
                        </b>
                      : null}
                    <span
                      className="progress-bar__file-name"
                      title="{f.uploadName}"
                    >
                      {f.uploadName}
                    </span>
                  </div>

                  <div className="progress-bar__holder">
                    <div
                      className="progress-bar__bar"
                      style={{ width: f.uploadProgress + "%" }}
                    />
                    <div className="progress-bar__percent">
                      {f.uploadStatus !== "ERROR"
                        ? <span>
                            {f.uploadProgress}%
                          </span>
                        : null}
                    </div>
                  </div>

                  {f.uploadStatus !== "COMPLETE"
                    ? <button
                        type="button"
                        className="progress-bar__abort progress-bar__button icon-only"
                        onClick={() => {
                          this.removeUploadFile(f);
                        }}
                      >
                        <i className="fa fa-fw fa-remove" />
                      </button>
                    : null}

                  {f.uploadStatus === "INPROGRESS"
                    ? <button
                        onClick={e => {
                          e.target.parentNode.style.display = "none";
                        }}
                        className="progress-bar__hide progress-bar__button icon-only"
                        type="button"
                      >
                        <i className="fa fa-fw fa-sort-desc" />
                      </button>
                    : null}
                </li>
              )}
            </ul>
          : null}
        <Loading />
        <Notifications notifications={notifications} />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
